import { Store } from "redux";
import * as Actions from './actions/actions';
import * as Reducers from './reducers/index';
//@ts-ignore
import * as postMessageUtilities from '@alme/ui-web/modules/lib-postmessage/lib/lib-postmessage';
import { AlightStateType } from "../../types/alight-state";
import { AlightCustomSettings } from "../../settings/alight-custom-settings";


export default class UserDetailsPostMessageHandler
{
    _settings: typeof AlightCustomSettings;
    _store: Store<AlightStateType> | undefined;

    constructor(passedSettings: typeof AlightCustomSettings){
        this._settings = passedSettings;
    }

    initialize(store: Store<AlightStateType>): void{   
        this._store = store;     
        postMessageUtilities.setupStateWatchForReceivedMessages(this._settings, this._store, this.processPostMessage.bind(this));
    }

    getReducer(){
        return Reducers.reducer;
    }

    processPostMessage(newVal: any): void
    {
        const msg = postMessageUtilities.getAndValidateMessage(newVal, 'userdetails');

        if (msg === null)
        {
            return;
        }

        const windowBase = this._settings.stateLocations.Window.Base;
        const UDPVarLocation  = `${this._settings.stateLocations.Window.UDPVars.Base}`;

        const UDPVarInput = {
            UUID: msg.message?.Data?.id,
        };

        this._store?.dispatch(Actions.setUDPVars(`${windowBase}.${UDPVarLocation}`, UDPVarInput ));

        postMessageUtilities.setIsProcessed(this._settings, this._store, msg.message);
        
        return;
    }
}


// WEBPACK FOOTER //
// ./modules/user-details-post-message/user-details-post-message-handler.ts